import styled from 'styled-components';

export const FormGroup = styled.div`
  display: flex;
  margin: 20px 0;
  & > *:not(:last-child) {
    margin-right: 15px;
  }
  & > * {
    flex: 1;
  }
  @media (max-width: 768px) {
    flex-direction: column;
    && > * {
      margin: 0 0 15px 0;
    }
  }
`;
